export default {
  'zh-cn': require('./locale/zh-cn.js').default,
};
